import {
  dayjsUTC,
  formatDateOnly,
  formatLocalDateTime,
  toCalendarDateString,
} from "../../utils/dates"
import type { PrecomputedBiothreatSignal } from "./types"

const formatOrderedActiveRange = (
  startInput: string | null | undefined,
  endInput: string | null | undefined
): string => {
  const start = toCalendarDateString(startInput)
  const end = toCalendarDateString(endInput)
  if (!start || !end) {
    return ""
  }

  const [earlier, later] = start <= end ? [start, end] : [end, start]
  const spanDays = Math.max(
    1,
    dayjsUTC(later).diff(dayjsUTC(earlier), "day") + 1
  )

  if (spanDays === 1) {
    return formatDateOnly(earlier)
  }

  return `${formatDateOnly(earlier)} – ${formatDateOnly(later)} (${spanDays}d)`
}

export const formatGdeltActiveDateRange = (
  signal: PrecomputedBiothreatSignal
): string => {
  const start = signal.gdelt_meta?.first_reported_at
  if (start && signal.publish_time) {
    return formatOrderedActiveRange(start, signal.publish_time)
  }
  return signal.publish_time ? formatLocalDateTime(signal.publish_time) : ""
}

export const formatNwssActiveDateRange = (
  signal: PrecomputedBiothreatSignal
): string => {
  const meta = signal.nwss_meta
  if (!meta) {
    return ""
  }
  if (meta.start_date && meta.last_detection_date) {
    return formatOrderedActiveRange(meta.start_date, meta.last_detection_date)
  }
  if (meta.start_date && meta.end_date) {
    return formatOrderedActiveRange(meta.start_date, meta.end_date)
  }
  return signal.publish_time ? formatDateOnly(signal.publish_time) : ""
}

export const formatBiothreatActiveDateRange = (
  signal: PrecomputedBiothreatSignal
): string =>
  signal.source === "gdelt"
    ? formatGdeltActiveDateRange(signal)
    : formatNwssActiveDateRange(signal)
